import type { Dictionary } from './en';

const de: Dictionary = {
  app: { name: 'Salon Suite', tagline: 'Alles, was Ihr Salon braucht – schön einfach.' },
  nav: {
    dashboard: 'Übersicht',
    calendar: 'Kalender',
    walkins: 'Laufkundschaft',
    clients: 'Kund:innen',
    pos: 'Kasse',
    invoices: 'Rechnungen',
    services: 'Leistungen',
    staff: 'Team',
    settings: 'Einstellungen',
    platform: 'Plattform',
    signOut: 'Abmelden',
    bookingPage: 'Buchungsseite',
  },
  common: {
    save: 'Speichern',
    saving: 'Wird gespeichert…',
    cancel: 'Abbrechen',
    close: 'Schließen',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    add: 'Hinzufügen',
    create: 'Erstellen',
    search: 'Suchen',
    loading: 'Wird geladen…',
    back: 'Zurück',
    next: 'Weiter',
    confirm: 'Bestätigen',
    yes: 'Ja',
    no: 'Nein',
    all: 'Alle',
    none: 'Keine',
    optional: 'optional',
    branch: 'Filiale',
    today: 'Heute',
    status: 'Status',
    total: 'Gesamt',
    actions: 'Aktionen',
    noResults: 'Noch nichts vorhanden',
    required: 'Pflichtfeld',
    language: 'English',
    theme: 'Dunkelmodus umschalten',
    export: 'CSV exportieren',
    import: 'CSV importieren',
    print: 'Drucken',
    minutes: 'Min.',
    anyStylist: 'Beliebige:r verfügbare:r Stylist:in',
    page: 'Seite {{page}} von {{total}}',
  },
  auth: {
    signIn: 'Anmelden',
    signInTitle: 'Willkommen zurück',
    signInSubtitle: 'Melden Sie sich an, um Ihren Salon zu verwalten',
    email: 'E-Mail',
    password: 'Passwort',
    noAccount: 'Neuer Salon?',
    createAccount: 'Salon anlegen',
    haveAccount: 'Bereits ein Konto?',
    registerTitle: 'Eröffnen Sie Ihren Salon bei Salon Suite',
    salonName: 'Name des Salons',
    ownerName: 'Ihr Name',
    phone: 'Telefon (WhatsApp)',
  },
  status: {
    PENDING: 'Ausstehend',
    CONFIRMED: 'Bestätigt',
    CHECKED_IN: 'Eingecheckt',
    IN_PROGRESS: 'In Behandlung',
    COMPLETED: 'Abgeschlossen',
    CANCELLED: 'Storniert',
    NO_SHOW: 'Nicht erschienen',
    ISSUED: 'Offen',
    PARTIALLY_PAID: 'Teilbezahlt',
    PAID: 'Bezahlt',
    PARTIALLY_REFUNDED: 'Teilerstattet',
    REFUNDED: 'Erstattet',
    VOID: 'Storniert',
    DRAFT: 'Entwurf',
    WAITING: 'Wartet',
    SERVING: 'In Bedienung',
    DONE: 'Fertig',
    LEFT: 'Gegangen',
  },
  dashboard: {
    greeting: 'Schön, Sie zu sehen, {{name}}',
    todayRevenue: 'Umsatz heute',
    todayAppointments: 'Termine heute',
    remaining: 'noch {{count}} ausstehend',
    periodRevenue: 'Umsatz (30 Tage)',
    avgTicket: 'Durchschnittsbon',
    newClients: 'Neukund:innen (30 Tage)',
    noShowRate: 'No-Show-Quote',
    revenueTrend: 'Umsatz der letzten 30 Tage',
    topServices: 'Top-Leistungen',
    upNext: 'Als Nächstes heute',
    staffLeaderboard: 'Team-Leistung',
    nothingNext: 'Heute keine weiteren Termine.',
    walkinsWaiting: '{{count}} Laufkund:innen warten',
  },
  calendar: {
    day: 'Tag',
    week: 'Woche',
    newAppointment: 'Neuer Termin',
    allStaff: 'Alle Stylist:innen',
    dragHint: 'Ziehen zum Verschieben · auf freien Platz klicken zum Buchen',
    moved: 'Termin verschoben',
    allergy: 'Allergie hinterlegt',
  },
  appointment: {
    client: 'Kund:in',
    services: 'Leistungen',
    stylist: 'Stylist:in',
    date: 'Datum',
    time: 'Uhrzeit',
    notes: 'Notizen',
    outsideHours: 'Buchung außerhalb der Arbeitszeit erlauben',
    notify: 'Bestätigung an Kund:in senden',
    addService: 'Leistung hinzufügen',
    pickTime: 'Uhrzeit wählen',
    customTime: 'Eigene Uhrzeit',
    noSlots: 'An diesem Tag ist nichts frei. Versuchen Sie ein anderes Datum oder eine andere Person.',
    book: 'Termin buchen',
    confirmAction: 'Bestätigen',
    checkIn: 'Einchecken',
    start: 'Behandlung starten',
    complete: 'Abschließen',
    noShow: 'Nicht erschienen',
    cancelAppt: 'Termin stornieren',
    reason: 'Grund',
    waiveFee: 'Stornogebühr erlassen',
    checkout: 'Kassieren',
    reschedule: 'Verschieben',
    reference: 'Ref.',
    deposit: 'Anzahlung',
    fee: 'Stornogebühr',
  },
  booking: {
    title: 'Termin buchen',
    chooseBranch: 'Standort wählen',
    chooseServices: 'Was dürfen wir für Sie tun?',
    chooseStylist: 'Stylist:in wählen',
    chooseTime: 'Datum & Uhrzeit wählen',
    yourDetails: 'Ihre Angaben',
    review: 'Prüfen & bestätigen',
    firstName: 'Vorname',
    lastName: 'Nachname',
    phone: 'Mobilnummer (WhatsApp)',
    email: 'E-Mail',
    notes: 'Sollten wir etwas wissen?',
    optIn: 'Angebote und Erinnerungen per WhatsApp erhalten',
    confirmBooking: 'Buchung bestätigen',
    booked: 'Ihr Termin ist gebucht!',
    bookedText: 'Wir haben Ihnen eine Bestätigung per WhatsApp geschickt. Bis bald!',
    manage: 'Buchung verwalten',
    bookAnother: 'Weiteren Termin buchen',
    selected: '{{count}} ausgewählt',
    duration: 'Dauer',
    from: 'ab',
    morning: 'Vormittag',
    afternoon: 'Nachmittag',
    evening: 'Abend',
    depositNote: 'Eine Anzahlung von {{amount}} sichert diesen Termin.',
    payDeposit: 'Anzahlung leisten',
    policy: 'Kostenlose Stornierung bis {{hours}} Stunden vor dem Termin.',
    cancelBooking: 'Buchung stornieren',
    cancelled: 'Diese Buchung wurde storniert.',
    callSalon: 'Um diese Buchung zu ändern, rufen Sie bitte den Salon an.',
    bookNow: 'Jetzt buchen',
    yourBooking: 'Ihre Buchung',
    changeTime: 'Uhrzeit ändern',
  },
  clients: {
    title: 'Kund:innen',
    newClient: 'Neue:r Kund:in',
    searchPlaceholder: 'Name, Telefon oder E-Mail suchen',
    visits: 'Besuche',
    spent: 'Umsatz gesamt',
    lastVisit: 'Letzter Besuch',
    allergy: 'Allergie',
    notes: 'Notizen',
    photos: 'Fotos',
    history: 'Verlauf',
    consent: 'Formulare',
    overview: 'Profil',
    addNote: 'Notiz hinzufügen',
    upload: 'Foto hochladen',
    sign: 'Ausfüllen & unterschreiben',
    firstName: 'Vorname',
    lastName: 'Nachname',
    phone: 'Telefon',
    email: 'E-Mail',
    gender: 'Geschlecht',
    birthday: 'Geburtstag',
    anniversary: 'Jahrestag',
    optIn: 'Marketing-Einwilligung',
    language: 'Bevorzugte Sprache',
    tags: 'Tags',
    importDone: 'Importiert: {{created}} neu, {{updated}} aktualisiert, {{errors}} Fehler',
  },
  pos: {
    title: 'Kasse',
    cart: 'Aktueller Verkauf',
    addItem: 'Hinzufügen',
    customItem: 'Freier Artikel',
    discount: 'Rabatt',
    tip: 'Trinkgeld',
    tax: 'MwSt.',
    subtotal: 'Zwischensumme',
    charge: '{{amount}} kassieren',
    payment: 'Zahlung annehmen',
    method: 'Zahlungsart',
    amount: 'Betrag',
    tendered: 'Erhaltenes Bargeld',
    change: 'Rückgeld',
    split: 'Zahlung aufteilen',
    remaining: 'Offen',
    paid: 'Zahlung erhalten',
    sendReceipt: 'Beleg per WhatsApp/E-Mail senden',
    newSale: 'Neuer Verkauf',
    register: 'Kassenlade',
    openRegister: 'Kasse öffnen',
    closeRegister: 'Kasse schließen',
    float: 'Wechselgeld-Anfangsbestand',
    counted: 'Gezähltes Bargeld',
    expected: 'Erwartetes Bargeld',
    variance: 'Differenz',
    registerClosed: 'Kasse ist geschlossen',
    refund: 'Erstattung',
    void: 'Rechnung stornieren',
    walkInSale: 'Laufkundschaft (ohne Kund:in)',
    CASH: 'Bar',
    CARD: 'Karte',
    WALLET: 'Wallet (PayPal / Apple Pay)',
    QR: 'QR-Code',
    BANK_TRANSFER: 'Überweisung',
    ONLINE: 'Online',
  },
  walkins: {
    title: 'Warteschlange',
    add: 'Laufkund:in hinzufügen',
    wait: '~{{min}} Min. Wartezeit',
    noEstimate: 'Keine Stylist:in verfügbar',
    serve: 'Starten',
    done: 'Fertig',
    left: 'Gegangen',
    empty: 'Niemand wartet. Prima!',
  },
  services: { title: 'Leistungen', newService: 'Neue Leistung', newCategory: 'Neue Kategorie', duration: 'Dauer', buffer: 'Puffer', price: 'Preis', deposit: 'Anzahlung', online: 'Online buchbar', followUp: 'Folgetermin nach (Wochen)', stylists: 'Wer bietet sie an' },
  staff: { title: 'Team', newMember: 'Teammitglied hinzufügen', schedule: 'Wochenplan', leave: 'Abwesenheit', role: 'Rolle', branches: 'Filialen', bookable: 'Nimmt Buchungen an', requestLeave: 'Abwesenheit beantragen', approve: 'Genehmigen', reject: 'Ablehnen', dayOff: 'Frei', breaks: 'Pausen', addBreak: 'Pause hinzufügen' },
  settings: { title: 'Einstellungen', general: 'Salon', booking: 'Buchungsregeln', branches: 'Filialen', templates: 'Nachrichten', roles: 'Rollen', forms: 'Einwilligungsformulare', widget: 'Website-Widget', audit: 'Audit-Protokoll', log: 'Nachrichtenprotokoll' },
  roles: { SUPER_ADMIN: 'Plattform-Admin', OWNER: 'Inhaber:in', MANAGER: 'Manager:in', RECEPTIONIST: 'Rezeption', STYLIST: 'Stylist:in', CLIENT: 'Kund:in' },
  days: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
};

export default de;
